(function () {
  function formatMoney(cents, fallbackFormat) {
    var value = Number(cents) || 0;
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      var format = fallbackFormat || (window.theme && theme.moneyFormat) || '${{amount}}';
      return Shopify.formatMoney(value, format).replace(/((\,00)|(\.00))$/, '');
    }
    return '$' + (value / 100).toFixed(2);
  }

  function cartAddUrl() {
    if (window.theme && theme.routes_cart_add_url) {
      return theme.routes_cart_add_url + '.js';
    }
    if (window.Shopify && Shopify.routes && Shopify.routes.root) {
      return Shopify.routes.root + 'cart/add.js';
    }
    return '/cart/add.js';
  }

  function productUrl(handle) {
    var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
    return root + 'products/' + encodeURIComponent(handle) + '.js';
  }

  function fetchAddonProduct(handle) {
    if (!handle) return Promise.resolve(null);
    fetchAddonProduct.cache = fetchAddonProduct.cache || {};
    if (fetchAddonProduct.cache[handle]) return fetchAddonProduct.cache[handle];
    fetchAddonProduct.cache[handle] = fetch(productUrl(handle), {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Could not load add-on product ' + handle + '.');
      return response.json();
    }).catch(function () {
      return null;
    });
    return fetchAddonProduct.cache[handle];
  }

  function selectedControls(group) {
    var controls = Array.prototype.slice.call(group.querySelectorAll('[data-mode-config-control]'));
    var selected = [];
    controls.forEach(function (control) {
      if (control.disabled) return;
      if (control.tagName === 'SELECT') {
        if (control.value) selected.push(control.options[control.selectedIndex]);
      } else if (control.type === 'checkbox' || control.type === 'radio') {
        if (control.checked) selected.push(control);
      } else if (control.value && control.value.trim()) {
        selected.push(control);
      }
    });
    return selected;
  }

  function selectedLabel(control) {
    if (control.dataset && control.dataset.choiceBaseLabel) return control.dataset.choiceBaseLabel;
    if (control.dataset && control.dataset.choiceLabel) return control.dataset.choiceLabel;
    if (control.tagName === 'OPTION') return control.textContent.trim();
    return control.value.trim();
  }

  function priceCents(control) {
    return Number(control.dataset && control.dataset.priceCents) || 0;
  }

  function livePriceCents(root, control) {
    var id = addonVariantId(control);
    var live = id && root._modeLivePrices && root._modeLivePrices[id];
    if (live && typeof live.price === 'number') return live.price;
    return priceCents(control);
  }

  function liveSku(root, control) {
    var id = addonVariantId(control);
    var live = id && root._modeLivePrices && root._modeLivePrices[id];
    if (live && live.sku) return live.sku;
    if (control.dataset && control.dataset.choiceSku) return control.dataset.choiceSku;
    return control.value ? String(control.value).replace(/_/g, ' ').toUpperCase() : '';
  }

  function addonVariantId(control) {
    var value = control.dataset && control.dataset.addonVariantId;
    if (!value || value === 'null') return null;
    return Number(String(value).split('/').pop()) || null;
  }

  function addonHandle(control) {
    var value = control.dataset && control.dataset.addonHandle;
    if (!value || value === 'null') return null;
    return value;
  }

  function optionPriceText(cents, root, compact) {
    if (cents <= 0) return '';
    return compact
      ? '+ ' + formatMoney(cents, root.dataset.moneyFormat)
      : ' (+ ' + formatMoney(cents, root.dataset.moneyFormat) + ')';
  }

  function updateControlPriceDisplay(root, control) {
    var label = selectedLabel(control);
    var price = optionPriceText(livePriceCents(root, control), root, false);
    var sku = liveSku(root, control);
    var text = label + price;
    if (sku && control.dataset) control.dataset.choiceSku = sku;

    if (control.tagName === 'OPTION') {
      control.textContent = text;
      return;
    }

    var wrapper = control.closest('label');
    if (!wrapper) return;
    var skuLabel = wrapper.querySelector('[data-mode-config-sku-label]');
    if (skuLabel) {
      skuLabel.textContent = sku;
      skuLabel.hidden = !sku;
    }
    var priceLabel = wrapper.querySelector('[data-mode-config-price-label]');
    if (priceLabel) {
      priceLabel.textContent = optionPriceText(
        livePriceCents(root, control),
        root,
        priceLabel.classList.contains('mode-configurator__swatch-price')
      );
    }
    if (wrapper.classList.contains('mode-configurator__swatch')) {
      wrapper.title = sku ? sku + ' - ' + text : text;
    }
  }

  function setControlAvailability(root, control, available) {
    if (typeof available !== 'boolean') return;
    control.disabled = !available;
    if (!available) {
      if (control.tagName === 'OPTION' && control.selected) control.selected = false;
      if (control.type === 'checkbox' || control.type === 'radio') control.checked = false;
    }
    var wrapper = control.tagName === 'OPTION'
      ? control.closest('select')
      : control.closest('label');
    if (wrapper) wrapper.classList.toggle('is-unavailable', !available);
  }

  function collectAddonHandles(root) {
    var handles = {};
    root.querySelectorAll('[data-mode-config-control]').forEach(function (control) {
      var handle = addonHandle(control);
      if (handle) handles[handle] = true;
      if (control.tagName === 'SELECT') {
        Array.prototype.slice.call(control.options).forEach(function (option) {
          handle = addonHandle(option);
          if (handle) handles[handle] = true;
        });
      }
    });
    return Object.keys(handles);
  }

  function priceControls(root) {
    var controls = [];
    root.querySelectorAll('[data-mode-config-control]').forEach(function (control) {
      if (control.tagName === 'SELECT') {
        controls = controls.concat(Array.prototype.slice.call(control.options).filter(function (option) {
          return option.dataset && option.dataset.choiceLabel;
        }));
      } else {
        controls.push(control);
      }
    });
    return controls;
  }

  function applyLivePricing(root) {
    priceControls(root).forEach(function (control) {
      var id = addonVariantId(control);
      var live = id && root._modeLivePrices && root._modeLivePrices[id];
      if (live) setControlAvailability(root, control, live.available);
      updateControlPriceDisplay(root, control);
    });

    root.querySelectorAll('select[data-mode-config-control]').forEach(function (select) {
      if (select.selectedIndex > -1 && select.options[select.selectedIndex].disabled) {
        select.selectedIndex = 0;
      }
    });
  }

  function applyInitialAvailability(root) {
    priceControls(root).forEach(function (control) {
      var value = control.dataset && control.dataset.addonAvailable;
      if (value === 'true') setControlAvailability(root, control, true);
      if (value === 'false') setControlAvailability(root, control, false);
      updateControlPriceDisplay(root, control);
    });

    root.querySelectorAll('select[data-mode-config-control]').forEach(function (select) {
      if (select.selectedIndex > -1 && select.options[select.selectedIndex].disabled) {
        select.selectedIndex = 0;
      }
    });
  }

  function loadLivePricing(root) {
    var handles = collectAddonHandles(root);
    if (handles.length === 0) return;
    root._modeLivePrices = {};
    Promise.all(handles.map(fetchAddonProduct)).then(function (products) {
      products.forEach(function (product) {
        if (!product || !Array.isArray(product.variants)) return;
        product.variants.forEach(function (variant) {
          root._modeLivePrices[variant.id] = {
            price: Number(variant.price),
            sku: variant.sku || '',
            available: variant.available !== false
          };
        });
      });
      applyLivePricing(root);
      updateTotal(root);
    });
  }

  function setError(group, message) {
    var error = group.querySelector('[data-mode-config-error]');
    if (!error) return;
    if (!message) {
      error.hidden = true;
      error.textContent = '';
      return;
    }
    error.hidden = false;
    error.textContent = message;
  }

  function setFeedback(root, message, kind) {
    var feedback = root.querySelector('[data-mode-config-feedback]');
    if (!feedback) return;
    if (!message) {
      feedback.hidden = true;
      feedback.textContent = '';
      feedback.classList.remove('is-error', 'is-success');
      return;
    }
    feedback.hidden = false;
    feedback.textContent = message;
    feedback.classList.toggle('is-error', kind === 'error');
    feedback.classList.toggle('is-success', kind === 'success');
  }

  function bundleToken() {
    return 'mode-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8);
  }

  function quantity(root) {
    var input = root.querySelector('[name="quantity"]');
    var value = input ? Number(input.value) : 1;
    if (!value || value < 1) return 1;
    return Math.floor(value);
  }

  function updateSwatchState(root) {
    root.querySelectorAll('.mode-configurator__swatch').forEach(function (label) {
      var input = label.querySelector('input');
      label.classList.toggle('is-selected', input && input.checked);
    });
  }

  function updateSelectedDescriptions(root) {
    root.querySelectorAll('[data-mode-config-group]').forEach(function (group) {
      var description = group.querySelector('[data-mode-config-selected-description]');
      var select = group.querySelector('select[data-mode-config-control]');
      if (!description || !select) return;
      var option = select.options[select.selectedIndex];
      var text = option && option.dataset ? option.dataset.choiceDescription : '';
      if (text) {
        description.hidden = false;
        description.textContent = text;
      } else {
        description.hidden = true;
        description.textContent = '';
      }
    });
  }

  function updateConfiguredSku(root, selection) {
    var container = root.closest('.product-container') || document;
    var sku = container.querySelector('[data-variant-sku]');
    if (!sku) return;

    var parts = [];
    if (root.dataset.parentSku) parts.push(root.dataset.parentSku);
    (selection.configuredSkus || []).forEach(function (part) {
      if (part) parts.push(part);
    });

    if (parts.length === 0) return;
    sku.textContent = parts.join(' + ');

    var skuWrap = sku.closest('.variant-sku');
    if (skuWrap) skuWrap.classList.remove('hidden');
    var skuSeparator = container.querySelector('[data-variant-sku-seperator]');
    if (skuSeparator && container.querySelector('[data-variant-vendor]')) {
      skuSeparator.classList.remove('hidden');
    }
  }

  function openImageDialog(root, trigger) {
    var dialog = root.querySelector('[data-mode-config-image-dialog]');
    var image = root.querySelector('[data-mode-config-image-large]');
    var caption = root.querySelector('[data-mode-config-image-caption]');
    var close = root.querySelector('[data-mode-config-image-close]');
    if (!dialog || !image || !trigger) return;

    var src = trigger.dataset.imageSrc;
    var alt = trigger.dataset.imageAlt || '';
    if (!src) return;

    image.src = src;
    image.alt = alt;
    if (caption) caption.textContent = alt;
    dialog.hidden = false;
    root._modeImageTrigger = trigger;
    if (close) close.focus();
  }

  function closeImageDialog(root) {
    var dialog = root.querySelector('[data-mode-config-image-dialog]');
    var image = root.querySelector('[data-mode-config-image-large]');
    if (!dialog || dialog.hidden) return;

    dialog.hidden = true;
    if (image) {
      image.removeAttribute('src');
      image.alt = '';
    }
    if (root._modeImageTrigger && typeof root._modeImageTrigger.focus === 'function') {
      root._modeImageTrigger.focus();
    }
    root._modeImageTrigger = null;
  }

  function bindImageDialog(root) {
    root.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-mode-config-image]');
      if (trigger && root.contains(trigger)) {
        event.preventDefault();
        event.stopPropagation();
        openImageDialog(root, trigger);
        return;
      }

      if (event.target.matches('[data-mode-config-image-dialog], [data-mode-config-image-close]')) {
        event.preventDefault();
        closeImageDialog(root);
      }
    }, true);

    root.addEventListener('keydown', function (event) {
      var trigger = event.target.closest('[data-mode-config-image]');
      if (trigger && (event.key === 'Enter' || event.key === ' ')) {
        event.preventDefault();
        openImageDialog(root, trigger);
        return;
      }

      if (event.key === 'Escape') {
        closeImageDialog(root);
      }
    });
  }

  function readSelection(root, validate) {
    var basePrice = Number(root.dataset.basePrice) || 0;
    var total = basePrice;
    var properties = {};
    var children = [];
    var configuredSkus = [];
    var valid = true;

    root.querySelectorAll('[data-mode-config-group]').forEach(function (group) {
      var groupId = group.dataset.groupId;
      var groupLabel = group.dataset.groupLabel || groupId;
      var required = group.dataset.required === 'true';
      var controls = selectedControls(group);
      setError(group, '');

      if (required && controls.length === 0) {
        if (validate) setError(group, 'Please choose an option.');
        valid = false;
        return;
      }

      if (controls.length === 0) return;

      var labels = [];
      controls.forEach(function (control) {
        var label = selectedLabel(control);
        var addonId = addonVariantId(control);
        var sku = liveSku(root, control);
        labels.push(label);
        if (sku) configuredSkus.push(sku);
        total += livePriceCents(root, control);
        if (addonId) {
          children.push({
            id: addonId,
            groupId: groupId,
            groupLabel: groupLabel,
            label: label,
            sku: sku
          });
        }
      });
      properties[groupLabel] = labels.join(', ');
    });

    var vin = root.querySelector('[data-mode-config-vin]');
    if (vin && vin.value.trim()) {
      properties['VIN No.'] = vin.value.trim().toUpperCase();
    }

    return {
      valid: valid,
      total: total,
      properties: properties,
      configuredSkus: configuredSkus,
      children: children
    };
  }

  function updateTotal(root) {
    var selection = readSelection(root, false);
    var total = root.querySelector('[data-mode-config-total]');
    if (total) total.textContent = formatMoney(selection.total, root.dataset.moneyFormat);
    updateConfiguredSku(root, selection);
    updateSwatchState(root);
    updateSelectedDescriptions(root);
  }

  function submit(root, button) {
    var selection = readSelection(root, true);
    if (!selection.valid) {
      setFeedback(root, 'Please complete the required selections.', 'error');
      return;
    }

    var parentVariantId = Number(root.dataset.parentVariantId);
    if (!parentVariantId) {
      setFeedback(root, 'This product is missing a parent variant.', 'error');
      return;
    }

    var token = bundleToken();
    var qty = quantity(root);
    var parentProperties = selection.properties;
    parentProperties['_bundle_id'] = token;
    parentProperties['_bundle_parent'] = 'true';

    var items = [{
      id: parentVariantId,
      quantity: qty,
      properties: parentProperties
    }];

    selection.children.forEach(function (child) {
      items.push({
        id: child.id,
        quantity: qty,
        properties: {
          '_bundle_id': token,
          '_bundle_parent': 'false'
        }
      });
    });

    button.disabled = true;
    button.dataset.idleLabel = button.dataset.idleLabel || button.textContent;
    button.textContent = 'Adding...';
    setFeedback(root, '', '');

    fetch(cartAddUrl(), {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      if (!response.ok) {
        return response.json().catch(function () {
          return {};
        }).then(function (payload) {
          throw new Error(payload.description || payload.message || 'Could not add this configuration to cart.');
        });
      }
      return response.json();
    }).then(function () {
      button.disabled = false;
      button.textContent = 'Added';
      setFeedback(root, 'Added to cart.', 'success');
      window.setTimeout(function () {
        button.textContent = button.dataset.idleLabel || 'Add to Cart';
      }, 1600);

      var productContainer = root.closest('.product-container');
      if (productContainer && productContainer.dataset.cart === 'true' && window.theme && theme.routes_cart_url) {
        window.location.href = theme.routes_cart_url;
        return;
      }
      if (typeof window.CartDrop === 'function') {
        window.CartDrop(false);
      }
    }).catch(function (error) {
      button.disabled = false;
      button.textContent = button.dataset.idleLabel || 'Add to Cart';
      setFeedback(root, error.message || 'Could not add this configuration to cart.', 'error');
    });
  }

  function init(root) {
    if (root._modeConfiguratorReady) return;
    root._modeConfiguratorReady = true;
    applyInitialAvailability(root);
    updateTotal(root);
    loadLivePricing(root);
    bindImageDialog(root);
    root.addEventListener('change', function () {
      updateTotal(root);
      setFeedback(root, '', '');
    });
    root.addEventListener('input', function (event) {
      if (event.target.matches('[data-mode-config-vin]')) {
        var pos = event.target.selectionStart;
        event.target.value = event.target.value.toUpperCase();
        event.target.setSelectionRange(pos, pos);
      }
      updateTotal(root);
    });
    var button = root.querySelector('[data-mode-config-add]');
    if (button) {
      button.addEventListener('click', function () {
        submit(root, button);
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-mode-configurator]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
